// extracted by mini-css-extract-plugin
export default {"MilestoneTemplates":"MilestoneTemplates_MilestoneTemplates__pGdPI","Templates":"MilestoneTemplates_Templates__kRCb1","NoTaskTemplate":"MilestoneTemplates_NoTaskTemplate__4npp0"};